import { InjectionToken } from '@angular/core';

export interface CbUiEnvironment {
  haveCommunicationHander?: boolean;
  web?: boolean;
  isCB?: boolean;
  xpointKey?: string | null;
}

export const CB_UI_ENV = new InjectionToken<CbUiEnvironment>('CB_UI_ENV');
